import { BaseDto } from "../base-dto";
import { ProductoAmazon } from "../productosAmazon/ProductoAmazon";

export class itemDto extends BaseDto {
    public cart_id!: number;
    public product_id!: number;
    public qty!: number;
    public unit_price!: number;
    public line_total!: number;
    public product_snapshot!: string;
    public producto_amazon!: ProductoAmazon;
}